// extracted by mini-css-extract-plugin
export default {"calculatorOptionsBtn":"calculator-options-btn__calculatorOptionsBtn___K5hyu"};